// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-qrcode-reader-content {
  position: relative;
}

.container-qrcode-reader {
  opacity: 1;
  transition: opacity 0.15s linear;
}
.container-qrcode-reader.blocked {
  opacity: 0.5;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.lock-icon {
  font-size: 50px;
  color: rgba(0, 0, 0, 0.91);
}`, "",{"version":3,"sources":["webpack://./src/components/supervision components/virtual-access/virtual-access.component.scss","webpack://./src/components/supervision%20components/virtual-access/virtual-access.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;ACCF;;ADEA;EACE,UAAA;EACA,gCAAA;ACCF;ADCE;EACE,YAAA;EACA,wBAAA;EACA,kCAAA;EACA,8BAAA;ACCJ;;ADGA;EACE,eAAA;EACA,0BAAA;ACAF","sourcesContent":[".container-qrcode-reader-content {\n  position: relative;\n}\n\n.container-qrcode-reader {\n  opacity: 1;\n  transition: opacity 0.15s linear;\n\n  &.blocked {\n    opacity: 0.5;\n    display: flex !important;\n    justify-content: center !important;\n    align-items: center !important;\n  }\n}\n\n.lock-icon {\n  font-size: 50px;\n  color: rgb(0, 0, 0, 0.91);\n}\n",".container-qrcode-reader-content {\n  position: relative;\n}\n\n.container-qrcode-reader {\n  opacity: 1;\n  transition: opacity 0.15s linear;\n}\n.container-qrcode-reader.blocked {\n  opacity: 0.5;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n}\n\n.lock-icon {\n  font-size: 50px;\n  color: rgba(0, 0, 0, 0.91);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
